import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-831f3676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skeleton-loader__content" }

import { TirPmSkeletonLoader } from 'tir-components';

export default /*#__PURE__*/_defineComponent({
  __name: 'project-settings-skeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TirPmSkeletonLoader), {
      width: "8rem",
      height: "8rem",
      borderRadius: "62.4375rem"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TirPmSkeletonLoader), {
        width: "100%",
        height: "3.5rem",
        borderRadius: ".375rem"
      }),
      _createVNode(_unref(TirPmSkeletonLoader), {
        width: "100%",
        height: "2.75rem",
        borderRadius: ".375rem"
      }),
      _createVNode(_unref(TirPmSkeletonLoader), {
        width: "100%",
        height: "2.75rem",
        borderRadius: ".375rem"
      })
    ])
  ], 64))
}
}

})